import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const  phaseRouter: Array<RouteRecordRaw> = [
    {
        path: '/phase',
        name: '资源位配置',
        component: Layout,
        meta: { title: '资源位配置', icon: 'icon-discount', alwaysShow: true },
        children: [
            {
                path: 'navigation',
                name: '首页导航icon',
                component: () => import('@/views/phase/HomeNavigation.vue'),
                meta: { title: '首页导航icon' }
            },
            {
                path: 'selected-brands',
                name: '首页精选品牌',
                component: () => import('@/views/phase/SelectedBrands.vue'),
                meta: { title: '首页精选品牌' }
            },
            {
                path: 'entrance-map',
                name: '首页入口图',
                component: () => import('@/views/phase/EntranceMap.vue'),
                meta: { title: '首页入口图' }
            },
            {
                path: 'slider',
                name: '首页轮播图',
                component: () => import('@/views/phase/HomeSlider.vue'),
                meta: { title: '首页轮播图' }
            },
            {
                path: 'home-channel',
                name: '首页蛋叔频道',
                component: () => import('@/views/phase/HomeChannel.vue'),
                meta: { title: '首页蛋叔频道' }
            },
            {
                path: 'selected-activities',
                name: '精选活动',
                component: () => import('@/views/phase/SelectedActivities.vue'),
                meta: { title: '精选活动' }
            },
            {
                path: 'home-recommend',
                name: '首页为你推荐',
                component: () => import('@/views/phase/HomeRecommend.vue'),
                meta: { title: '首页为你推荐' }
            },
            {
                path: 'home-marquee',
                name: '首页跑马灯',
                component: () => import('@/views/phase/HomeMarquee.vue'),
                meta: { title: '首页跑马灯' }
            },
            {
                path: 'home-coupon',
                name: '首页领券中心',
                component: () => import('@/views/phase/HomeCoupon.vue'),
                meta: { title: '首页领券中心' }
            },
            {
                path: 'cakes_slider',
                name: '蛋糕轮播',
                component: () => import('@/views/phase/CakesSlider.vue'),
                meta: { title: '蛋糕轮播' }
            },
            {
                path: 'cakes_pick',
                name: '蛋糕用心挑选',
                component: () => import('@/views/phase/CakesPick.vue'),
                meta: { title: '蛋糕用心挑选' }
            },
            {
                path: 'cakes_recommend',
                name: '蛋糕为你推荐',
                component: () => import('@/views/phase/CakesRecommend.vue'),
                meta: { title: '蛋糕为你推荐' }
            },
            {
                path: 'search_brands',
                name: '搜索页品牌设置',
                component: () => import('@/views/phase/SearchBrands.vue'),
                meta: { title: '搜索页品牌设置' }
            },
        ]
    }
]

export default  phaseRouter